import { render, staticRenderFns } from "./MasterVendor.vue?vue&type=template&id=2518aa1c&scoped=true"
import script from "./MasterVendor.vue?vue&type=script&lang=js"
export * from "./MasterVendor.vue?vue&type=script&lang=js"
import style0 from "./MasterVendor.vue?vue&type=style&index=0&id=2518aa1c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2518aa1c",
  null
  
)

export default component.exports